var globalAddonsCurrentIndex = 0;


function globalAddonsMoveForward()
{
  if(globalAddonsCurrentIndex == globalAddonsIndexTotal - 1 )
  {
    return;
  }
  globalAddonsCurrentIndex++;
  globalAddonsSetActiveCard(globalAddonsCurrentIndex);
}

function globalAddonsMoveBack()
{
  if(globalAddonsCurrentIndex == 0 )
  {
    return;
  }

  globalAddonsCurrentIndex--;
  globalAddonsSetActiveCard(globalAddonsCurrentIndex);
}

function globalAddonsSetActiveCard(activeCardIndex)
{

  const flexContainer = document.querySelector('.nw-pdp-addons-items');
  const flexWrapper = document.querySelector('.nw-pdp-addons-items-wrapper');
  const scrollAmount = flexContainer.offsetWidth / 2;
  const amountToScroll = scrollAmount * activeCardIndex;

  console.log("scrollAmount = " + scrollAmount + " | activeCardIndex = " + activeCardIndex  + " | amountToScroll = "+ amountToScroll);
  
  const previousActiveDot =   document.querySelector('.nw-pdp-addons-items-controls-dot[suggestionDotActive="true"] ');
  previousActiveDot.setAttribute("suggestionDotActive", "false");
  const newActiveDot = document.querySelector('.nw-pdp-addons-items-controls-dot[suggestioncardindex="'+activeCardIndex+'"] ');
  newActiveDot.setAttribute("suggestionDotActive", "true");

  

  flexWrapper.scrollLeft = amountToScroll;
  
  globalAddonsCurrentIndex = activeCardIndex;

  const backButton = document.querySelector('.nw-pdp-addons-items-controls-button-back');
  const forwardButton = document.querySelector('.nw-pdp-addons-items-controls-button-forward');

  backButton.classList.remove("nw-pdp-addons-items-controls-button-disabled");
  forwardButton.classList.remove("nw-pdp-addons-items-controls-button-disabled");
  backButton.classList.remove("nw-pdp-addons-items-controls-button-enabled");
  forwardButton.classList.remove("nw-pdp-addons-items-controls-button-enabled");

  if(globalAddonsCurrentIndex == 0 )
  {
    backButton.classList.add("nw-pdp-addons-items-controls-button-disabled");
  }
  else
  {
    backButton.classList.add("nw-pdp-addons-items-controls-button-enabled");
  }
  if(globalAddonsCurrentIndex == globalAddonsIndexTotal - 1 )
  {
    forwardButton.classList.add("nw-pdp-addons-items-controls-button-disabled");
  }
  else
  {
    forwardButton.classList.add("nw-pdp-addons-items-controls-button-enabled");
  }
}